import React from "react";

const NewAiBadge = ({ width = 54, height = 16 }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 54 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="54" height="16" rx="8" fill="url(#paint0_linear_3050_51334)" />
		<g clipPath="url(#clip0_3050_51334)">
			<path
				d="M12.4097 2.09353C11.8008 5.40077 11.3072 5.89432 8 6.50318C11.3072 7.11203 11.8008 7.60558 12.4097 10.9128C13.0185 7.60558 13.5121 7.11203 16.8193 6.50318C13.5121 5.89432 13.0185 5.40077 12.4097 2.09353Z"
				fill="#004BA9"
			/>
			<path
				d="M17.195 8.29788C16.8078 10.4011 16.4939 10.7151 14.3906 11.1022C16.4939 11.4894 16.8078 11.8034 17.195 13.9066C17.5822 11.8034 17.8961 11.4894 19.9993 11.1022C17.8961 10.7151 17.5822 10.4011 17.195 8.29788Z"
				fill="#004BA9"
			/>
		</g>
		<path
			d="M28.7152 4.72727V12H27.3871L24.223 7.42259H24.1697V12H22.6321V4.72727H23.9815L27.1207 9.30114H27.1847V4.72727H28.7152ZM29.9856 12V4.72727H34.8862V5.99503H31.5233V7.72798H34.6341V8.99574H31.5233V10.7322H34.9004V12H29.9856ZM37.7457 12L35.6648 4.72727H37.3445L38.5483 9.78054H38.6087L39.9368 4.72727H41.375L42.6996 9.79119H42.7635L43.9673 4.72727H45.647L43.5661 12H42.0675L40.6825 7.24503H40.6257L39.2443 12H37.7457Z"
			fill="#004BA9"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_3050_51334"
				x1="-11.8983"
				y1="7.6"
				x2="65.8983"
				y2="7.6"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B5D4FF" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
			<clipPath id="clip0_3050_51334">
				<rect width="12" height="12" fill="white" transform="translate(8 2)" />
			</clipPath>
		</defs>
	</svg>
);

export default NewAiBadge;
